// extracted by mini-css-extract-plugin
export default {"wrapper":"jnTuJBZ","quickActionsTrigger":"Zn99Y7N","actionsMenu":"ny6WWnU","quickActionButton":"Q8ssFAh"};